import I18n from 'i18n-js'

const _t = I18n.t.bind(I18n)

I18n.t = function (message, options): string {
  const defaultInterpolations = window.defaultInterpolations ?? {}

  return _t(message, {
    ...defaultInterpolations,
    ...options,
  })
}

export default I18n
